import type { RootState } from "@/src/common/redux/store";

export const getUser = (state: RootState) => state.auth.user;
export const getIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export const getCsrfToken = (state: RootState) => state.auth.csrfToken;
